import angular from 'angular';
import userListComponent from './user-list.component';

export default angular.module('components.app.account.user-list', [])
  .component('userList', userListComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/common/user-list/user-list.module.js